export default __webpack_public_path__ + "static/media/PS5-1.66e2e6fb.jpg";